var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _vm._v("\n    " + _vm._s(_vm.content?.title) + "\n    "),
      _vm.content
        ? _c(_setup.ContentTypeLabel, {
            staticClass: "ms-1",
            attrs: { "content-type-id": _vm.content.contentType },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }